import React from 'react';
import styled from 'styled-components';
import Theme from '../../../Theme';
import {Link} from 'gatsby';
import {useOutlet} from 'reconnect.js';

function Landing(props) {
  const [about] = useOutlet('about');

  return (
    <Wrapper>
      <img src="/images/site-logo.png" alt="logo" className="logo" />

      <h1>社團法人台北市牙醫師公會</h1>
      <h2>Taipei Dental Association</h2>

      <div className="items">
        <Link to="/doctor">
          <img
            src="/images/navigation-doctor.png"
            alt="navigation-doctor"
            className="navigation"
          />
        </Link>
        <div style={{width: 20}} />
        <Link to="/people">
          <img
            src="/images/navigation-people.png"
            alt="navigation-people"
            className="navigation"
          />
        </Link>
      </div>

      <div className="items" style={{marginTop: 30, marginBottom: 10}}>
        <div className="info-item">{about?.information?.address}</div>
        <div className="info-item">
          <span className="label">電話:</span> {about?.information?.phone}
        </div>
        <div className="info-item">
          <span className="label">傳真:</span> {about?.information?.fax}
        </div>
        <div className="info-item">
          <span className="label">信箱:</span> {about?.information.mail}
        </div>
      </div>
      <div className="items" style={{marginBottom: 10}}>
        <div className="info-item">
          <span className="label">郵政劃撥帳號:</span> 01068925{' '}
        </div>
        <div className="info-item">
          <span className="label">戶名:</span> 社團法人台北市牙醫師公會
        </div>
      </div>

      <div className="bottom">
        <div>
          © 2015-{new Date().getFullYear()} 社團法人台北市牙醫師公會 Taipei
          Dental Association(TDA). All rights reserved.
        </div>
        <div>
          designed by <a href="https://www.revtel.tech/">忻旅科技</a>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-bottom: 80px;
  padding-top: var(--topNavBarHeight);
  text-align: center;

  & img.logo {
    width: 200px;
    margin-bottom: 20px;
  }

  & h1 {
    font-size: 2rem;
    margin-bottom: 0px;
  }
  & h2 {
    font-size: 1.2rem;
    margin-bottom: 20px;
  }

  & img.navigation {
    width: 130px;
  }

  & > .items {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  & .info-item {
    margin-right: 10px;
    flex-shrink: 0;
    & > .label {
      font-weight: bold;
    }
  }

  & .bottom,
  .bottom a {
    font-size: 12px;
    color: #ccc;
  }

  @media (max-width: ${Theme.breakpoint}px) {
    & img.logo {
      width: 120px;
    }
    & h1 {
      font-size: 1.5rem;
    }
    & h2 {
      font-size: 1.1rem;
    }
  }
`;

export default Landing;
